import { useState } from "react";

interface SeoPage {
  path: string;
  label: string;
  title: string | null;
  description: string | null;
  keywords: string | null;
  h1: string | null;
  priority: "high" | "medium" | "low";
  category: string;
}

const SEO_PAGES: SeoPage[] = [
  // Ana sayfalar
  { path: "/", label: "Ana Sayfa", title: "Türkiye Seyahat Rehberi | Geziturkiyem", description: "Türkiye'nin en güzel şehirleri, mekanları, restoranları ve konaklama seçenekleri için kapsamlı seyahat rehberi.", keywords: "türkiye seyahat, gezilecek yerler, türkiye rehberi", h1: "Türkiye Seyahat Rehberi", priority: "high", category: "Ana Sayfalar" },
  { path: "/places", label: "Mekanlar", title: "Türkiye'nin En Güzel Mekanları | Geziturkiyem", description: "Kapadokya, Pamukkale, Efes ve daha fazlası — Türkiye'nin en etkileyici doğal ve tarihi mekanları.", keywords: "türkiye mekanlar, gezilecek yerler, tarihi mekanlar", h1: "Türkiye'nin En Güzel Mekanları", priority: "high", category: "Ana Sayfalar" },
  { path: "/restoranlar", label: "Restoranlar", title: "Türkiye'nin En İyi Restoranları | Geziturkiyem", description: "Türk mutfağının en iyi temsilcileri — şehir şehir restoran rehberi, yorumlar ve öneriler.", keywords: "türkiye restoranlar, türk mutfağı, yemek rehberi", h1: "Türkiye'nin En İyi Restoranları", priority: "high", category: "Ana Sayfalar" },
  { path: "/articles", label: "Makaleler", title: "Seyahat Makaleleri | Geziturkiyem", description: "Türkiye seyahati için kapsamlı rehberler, ipuçları ve yerel deneyimler.", keywords: "seyahat makaleleri, türkiye rehberi, gezi yazıları", h1: "Seyahat Makaleleri", priority: "high", category: "Ana Sayfalar" },
  { path: "/accommodations", label: "Konaklama", title: "Türkiye'de Konaklama | Geziturkiyem", description: "Butik oteller, pansiyonlar, glamping ve kamp alanları — Türkiye'nin en iyi konaklama seçenekleri.", keywords: "türkiye konaklama, otel, pansiyon, glamping", h1: "Türkiye'de Konaklama", priority: "high", category: "Ana Sayfalar" },
  { path: "/duyurular", label: "Duyurular", title: "Duyurular & Haberler | Geziturkiyem", description: "Türkiye seyahatiyle ilgili son haberler, kampanyalar ve duyurular.", keywords: "seyahat haberleri, türkiye duyurular, kampanyalar", h1: "Duyurular & Haberler", priority: "medium", category: "Ana Sayfalar" },

  // Şehir SSS Sayfaları
  { path: "/istanbul-sss", label: "İstanbul SSS", title: "İstanbul Seyahat Rehberi & Sık Sorulan Sorular | Geziturkiyem", description: "İstanbul'a seyahat planlayanlar için kapsamlı rehber: gezilecek yerler, ulaşım, konaklama ve ipuçları.", keywords: "istanbul seyahat, istanbul gezilecek yerler, istanbul rehberi", h1: "İstanbul Seyahat Rehberi", priority: "high", category: "Şehir SSS" },
  { path: "/kapadokya-sss", label: "Kapadokya SSS", title: "Kapadokya Seyahat Rehberi & Sık Sorulan Sorular | Geziturkiyem", description: "Kapadokya'ya seyahat planlayanlar için kapsamlı rehber: balon turu, peri bacaları, konaklama ve daha fazlası.", keywords: "kapadokya seyahat, kapadokya balon turu, kapadokya rehberi", h1: "Kapadokya Seyahat Rehberi", priority: "high", category: "Şehir SSS" },
  { path: "/antalya-sss", label: "Antalya SSS", title: "Antalya Seyahat Rehberi & Sık Sorulan Sorular | Geziturkiyem", description: "Antalya'ya seyahat planlayanlar için kapsamlı rehber: plajlar, tarihi mekanlar, konaklama ve ipuçları.", keywords: "antalya seyahat, antalya plajlar, antalya rehberi", h1: "Antalya Seyahat Rehberi", priority: "high", category: "Şehir SSS" },
  { path: "/izmir-sss", label: "İzmir SSS", title: "İzmir Seyahat Rehberi & Sık Sorulan Sorular | Geziturkiyem", description: "İzmir'e seyahat planlayanlar için kapsamlı rehber: Kordon, Kemeraltı, Çeşme ve daha fazlası.", keywords: "izmir seyahat, izmir gezilecek yerler, izmir rehberi", h1: "İzmir Seyahat Rehberi", priority: "high", category: "Şehir SSS" },
  { path: "/mardin-sss", label: "Mardin SSS", title: "Mardin Seyahat Rehberi & Sık Sorulan Sorular | Geziturkiyem", description: "Mardin'e seyahat planlayanlar için kapsamlı rehber: tarihi taş evler, manastırlar ve Mezopotamya kültürü.", keywords: "mardin seyahat, mardin gezilecek yerler, mardin rehberi", h1: "Mardin Seyahat Rehberi", priority: "medium", category: "Şehir SSS" },
  { path: "/trabzon-sss", label: "Trabzon SSS", title: "Trabzon Seyahat Rehberi & Sık Sorulan Sorular | Geziturkiyem", description: "Trabzon'a seyahat planlayanlar için kapsamlı rehber: Uzungöl, Sümela Manastırı ve Karadeniz yaylaları.", keywords: "trabzon seyahat, trabzon gezilecek yerler, trabzon rehberi", h1: "Trabzon Seyahat Rehberi", priority: "medium", category: "Şehir SSS" },
  { path: "/sakarya-sss", label: "Sakarya SSS", title: "Sakarya Seyahat Rehberi & Sık Sorulan Sorular | Geziturkiyem", description: "Sakarya'ya seyahat planlayanlar için kapsamlı rehber: Sapanca Gölü, doğa yürüyüşleri ve kamp alanları.", keywords: "sakarya seyahat, sapanca gölü, sakarya rehberi", h1: "Sakarya Seyahat Rehberi", priority: "medium", category: "Şehir SSS" },
  { path: "/kocaeli-sss", label: "Kocaeli SSS", title: "Kocaeli Seyahat Rehberi & Sık Sorulan Sorular | Geziturkiyem", description: "Kocaeli'ye seyahat planlayanlar için kapsamlı rehber: Kartepe, Izmit Körfezi ve doğa aktiviteleri.", keywords: "kocaeli seyahat, kartepe, kocaeli rehberi", h1: "Kocaeli Seyahat Rehberi", priority: "medium", category: "Şehir SSS" },
  { path: "/bolu-sss", label: "Bolu SSS", title: "Bolu Seyahat Rehberi & Sık Sorulan Sorular | Geziturkiyem", description: "Bolu'ya seyahat planlayanlar için kapsamlı rehber: Abant Gölü, Yedigöller ve doğa yürüyüşleri.", keywords: "bolu seyahat, abant gölü, bolu rehberi", h1: "Bolu Seyahat Rehberi", priority: "medium", category: "Şehir SSS" },
  { path: "/gaziantep-sss", label: "Gaziantep SSS", title: "Gaziantep Seyahat Rehberi & Sık Sorulan Sorular | Geziturkiyem", description: "Gaziantep'e seyahat planlayanlar için kapsamlı rehber: baklava, Zeugma Mozaik Müzesi ve gastronomi.", keywords: "gaziantep seyahat, gaziantep baklava, gaziantep rehberi", h1: "Gaziantep Seyahat Rehberi", priority: "medium", category: "Şehir SSS" },

  // Rehber Sayfaları
  { path: "/guides/karadeniz-yayla-rehberi", label: "Karadeniz Yayla Rehberi", title: "Karadeniz Yayla Rehberi | Geziturkiyem", description: "Karadeniz'in eşsiz yaylalarını keşfedin: Ayder, Uzungöl, Pokut ve daha fazlası için kapsamlı rehber.", keywords: "karadeniz yaylalar, yayla turu, karadeniz rehberi", h1: "Karadeniz Yayla Rehberi", priority: "medium", category: "Rehberler" },
  { path: "/guides/gunubirlik-kacamaklar", label: "Günübirlik Kaçamaklar", title: "Türkiye'de Günübirlik Kaçamaklar | Geziturkiyem", description: "İstanbul, Ankara ve İzmir'den günübirlik yapılabilecek en güzel kaçamak rotaları ve öneriler.", keywords: "günübirlik gezi, hafta sonu kaçamak, türkiye gezi", h1: "Günübirlik Kaçamaklar", priority: "medium", category: "Rehberler" },

  // Başvuru Sayfaları
  { path: "/restaurant-apply", label: "Restoran Başvurusu", title: null, description: null, keywords: null, h1: null, priority: "low", category: "Başvuru Sayfaları" },
  { path: "/hotel-apply", label: "Konaklama Başvurusu", title: null, description: null, keywords: null, h1: null, priority: "low", category: "Başvuru Sayfaları" },
  { path: "/gold-apply", label: "Gold Üyelik", title: null, description: null, keywords: null, h1: null, priority: "low", category: "Başvuru Sayfaları" },
];

const scoreColor = (score: number) => {
  if (score >= 80) return "text-emerald-600 bg-emerald-50";
  if (score >= 50) return "text-amber-600 bg-amber-50";
  return "text-rose-600 bg-rose-50";
};

const scoreBg = (score: number) => {
  if (score >= 80) return "bg-emerald-400";
  if (score >= 50) return "bg-amber-400";
  return "bg-rose-400";
};

const calcScore = (page: SeoPage): number => {
  let score = 0;
  if (page.title) score += 30;
  if (page.description) score += 30;
  if (page.keywords) score += 20;
  if (page.h1) score += 20;
  return score;
};

const CATEGORIES = ["Tümü", "Ana Sayfalar", "Şehir SSS", "Rehberler", "Başvuru Sayfaları"];

const SeoStatus = () => {
  const [activeCategory, setActiveCategory] = useState("Tümü");
  const [filterStatus, setFilterStatus] = useState<"all" | "ok" | "warning" | "error">("all");
  const [expandedPath, setExpandedPath] = useState<string | null>(null);

  const filtered = SEO_PAGES.filter((p) => {
    const catMatch = activeCategory === "Tümü" || p.category === activeCategory;
    const score = calcScore(p);
    const statusMatch =
      filterStatus === "all" ||
      (filterStatus === "ok" && score >= 80) ||
      (filterStatus === "warning" && score >= 50 && score < 80) ||
      (filterStatus === "error" && score < 50);
    return catMatch && statusMatch;
  });

  const totalPages = SEO_PAGES.length;
  const okPages = SEO_PAGES.filter((p) => calcScore(p) >= 80).length;
  const warnPages = SEO_PAGES.filter((p) => { const s = calcScore(p); return s >= 50 && s < 80; }).length;
  const errorPages = SEO_PAGES.filter((p) => calcScore(p) < 50).length;
  const avgScore = Math.round(SEO_PAGES.reduce((s, p) => s + calcScore(p), 0) / totalPages);

  const missingTitles = SEO_PAGES.filter((p) => !p.title).length;
  const missingDescs = SEO_PAGES.filter((p) => !p.description).length;
  const missingKeywords = SEO_PAGES.filter((p) => !p.keywords).length;
  const missingH1 = SEO_PAGES.filter((p) => !p.h1).length;

  return (
    <div>
      {/* Header */}
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <div>
          <h2 className="text-xl font-bold text-stone-900" style={{ fontFamily: "'Playfair Display', serif" }}>
            SEO Durumu
          </h2>
          <p className="text-stone-400 text-xs mt-0.5">Tüm sayfaların meta etiket ve SEO sağlığı</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <div className={`flex items-center gap-2 px-4 py-2 rounded-xl ${scoreColor(avgScore)}`}>
            <i className="ri-bar-chart-fill text-sm"></i>
            <span className="text-sm font-bold">Ortalama SEO Skoru: {avgScore}/100</span>
          </div>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
        <div className="bg-white rounded-xl border border-stone-100 p-5 text-center">
          <p className="text-3xl font-bold text-stone-900">{totalPages}</p>
          <p className="text-xs text-stone-500 mt-1">Toplam Sayfa</p>
        </div>
        <div
          className="bg-emerald-50 rounded-xl border border-emerald-100 p-5 text-center cursor-pointer hover:border-emerald-300 transition-colors"
          onClick={() => setFilterStatus(filterStatus === "ok" ? "all" : "ok")}
        >
          <p className="text-3xl font-bold text-emerald-600">{okPages}</p>
          <p className="text-xs text-stone-500 mt-1 flex items-center justify-center gap-1">
            <i className="ri-checkbox-circle-line text-emerald-500"></i> İyi (80+)
          </p>
        </div>
        <div
          className="bg-amber-50 rounded-xl border border-amber-100 p-5 text-center cursor-pointer hover:border-amber-300 transition-colors"
          onClick={() => setFilterStatus(filterStatus === "warning" ? "all" : "warning")}
        >
          <p className="text-3xl font-bold text-amber-600">{warnPages}</p>
          <p className="text-xs text-stone-500 mt-1 flex items-center justify-center gap-1">
            <i className="ri-alert-line text-amber-500"></i> Orta (50-79)
          </p>
        </div>
        <div
          className="bg-rose-50 rounded-xl border border-rose-100 p-5 text-center cursor-pointer hover:border-rose-300 transition-colors"
          onClick={() => setFilterStatus(filterStatus === "error" ? "all" : "error")}
        >
          <p className="text-3xl font-bold text-rose-600">{errorPages}</p>
          <p className="text-xs text-stone-500 mt-1 flex items-center justify-center gap-1">
            <i className="ri-close-circle-line text-rose-500"></i> Eksik (0-49)
          </p>
        </div>
      </div>

      {/* Missing Fields Summary */}
      <div className="bg-white rounded-xl border border-stone-100 p-5 mb-6">
        <h3 className="text-sm font-bold text-stone-800 mb-4 flex items-center gap-2">
          <i className="ri-error-warning-line text-amber-500"></i> Eksik Alan Özeti
        </h3>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {[
            { label: "Eksik Title", count: missingTitles, icon: "ri-text", color: "text-rose-500 bg-rose-50" },
            { label: "Eksik Description", count: missingDescs, icon: "ri-file-text-line", color: "text-amber-500 bg-amber-50" },
            { label: "Eksik Keywords", count: missingKeywords, icon: "ri-key-2-line", color: "text-amber-500 bg-amber-50" },
            { label: "Eksik H1", count: missingH1, icon: "ri-heading", color: "text-rose-500 bg-rose-50" },
          ].map((item) => (
            <div key={item.label} className={`flex items-center gap-3 p-3 rounded-xl ${item.color.split(" ")[1]}`}>
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg ${item.color.split(" ")[1]}`}>
                <i className={`${item.icon} ${item.color.split(" ")[0]} text-sm`}></i>
              </div>
              <div>
                <p className={`text-xl font-bold ${item.color.split(" ")[0]}`}>{item.count}</p>
                <p className="text-xs text-stone-500">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Filters */}
      <div className="flex items-center gap-3 mb-4 flex-wrap">
        <div className="flex items-center bg-stone-100 rounded-full p-1 gap-1 flex-wrap">
          {CATEGORIES.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`text-xs px-3 py-1.5 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap
                ${activeCategory === cat ? "bg-white text-stone-800" : "text-stone-500 hover:text-stone-700"}`}
            >
              {cat}
            </button>
          ))}
        </div>
        {filterStatus !== "all" && (
          <button
            onClick={() => setFilterStatus("all")}
            className="flex items-center gap-1 text-xs px-3 py-1.5 bg-stone-200 text-stone-600 rounded-full hover:bg-stone-300 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-close-line"></i> Filtreyi Kaldır
          </button>
        )}
      </div>

      {/* Pages List */}
      <div className="space-y-2">
        {filtered.map((page) => {
          const score = calcScore(page);
          const isExpanded = expandedPath === page.path;
          const checks = [
            { label: "Title", value: page.title, maxLen: 60 },
            { label: "Description", value: page.description, maxLen: 160 },
            { label: "Keywords", value: page.keywords, maxLen: null },
            { label: "H1", value: page.h1, maxLen: null },
          ];

          return (
            <div
              key={page.path}
              className="bg-white rounded-xl border border-stone-100 overflow-hidden"
            >
              <button
                onClick={() => setExpandedPath(isExpanded ? null : page.path)}
                className="w-full text-left p-4 flex items-center gap-4 hover:bg-stone-50 transition-colors cursor-pointer"
              >
                {/* Score Badge */}
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl flex-shrink-0 font-bold text-sm ${scoreColor(score)}`}>
                  {score}
                </div>

                {/* Page Info */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-sm font-semibold text-stone-800">{page.label}</span>
                    <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                      page.priority === "high" ? "bg-rose-100 text-rose-600" :
                      page.priority === "medium" ? "bg-amber-100 text-amber-600" :
                      "bg-stone-100 text-stone-500"
                    }`}>
                      {page.priority === "high" ? "Yüksek Öncelik" : page.priority === "medium" ? "Orta Öncelik" : "Düşük Öncelik"}
                    </span>
                    <span className="text-xs text-stone-400 bg-stone-100 px-2 py-0.5 rounded-full">{page.category}</span>
                  </div>
                  <p className="text-xs text-stone-400 font-mono">{page.path}</p>
                </div>

                {/* Check Icons */}
                <div className="flex items-center gap-1.5 flex-shrink-0">
                  {checks.map((c) => (
                    <div
                      key={c.label}
                      title={`${c.label}: ${c.value ? "Mevcut" : "Eksik"}`}
                      className={`w-6 h-6 flex items-center justify-center rounded-full text-xs ${
                        c.value ? "bg-emerald-100 text-emerald-600" : "bg-rose-100 text-rose-500"
                      }`}
                    >
                      <i className={c.value ? "ri-check-line" : "ri-close-line"}></i>
                    </div>
                  ))}
                </div>

                {/* Score Bar */}
                <div className="w-24 flex-shrink-0 hidden sm:block">
                  <div className="h-2 bg-stone-100 rounded-full overflow-hidden">
                    <div
                      className={`h-full rounded-full transition-all duration-700 ${scoreBg(score)}`}
                      style={{ width: `${score}%` }}
                    ></div>
                  </div>
                  <p className="text-xs text-stone-400 mt-1 text-right">{score}/100</p>
                </div>

                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className={isExpanded ? "ri-arrow-up-s-line text-stone-400" : "ri-arrow-down-s-line text-stone-400"}></i>
                </div>
              </button>

              {/* Expanded Detail */}
              {isExpanded && (
                <div className="border-t border-stone-100 p-4 bg-stone-50">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {checks.map((c) => (
                      <div key={c.label} className={`p-3 rounded-xl border ${c.value ? "bg-white border-emerald-100" : "bg-rose-50 border-rose-100"}`}>
                        <div className="flex items-center gap-2 mb-1.5">
                          <div className={`w-5 h-5 flex items-center justify-center rounded-full ${c.value ? "bg-emerald-100" : "bg-rose-100"}`}>
                            <i className={`text-xs ${c.value ? "ri-check-line text-emerald-600" : "ri-close-line text-rose-500"}`}></i>
                          </div>
                          <span className="text-xs font-bold text-stone-700">{c.label}</span>
                          {c.maxLen && c.value && (
                            <span className={`text-xs px-1.5 py-0.5 rounded-full ${c.value.length > c.maxLen ? "bg-amber-100 text-amber-600" : "bg-stone-100 text-stone-500"}`}>
                              {c.value.length}/{c.maxLen}
                            </span>
                          )}
                        </div>
                        {c.value ? (
                          <p className="text-xs text-stone-600 leading-relaxed">{c.value}</p>
                        ) : (
                          <p className="text-xs text-rose-500 italic">Eksik — eklenmesi önerilir</p>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* Recommendations */}
                  {score < 100 && (
                    <div className="mt-3 p-3 bg-amber-50 rounded-xl border border-amber-100">
                      <p className="text-xs font-semibold text-amber-700 mb-1.5 flex items-center gap-1">
                        <i className="ri-lightbulb-line"></i> Öneriler
                      </p>
                      <ul className="space-y-1">
                        {!page.title && <li className="text-xs text-amber-700">• Title etiketi ekleyin (max 60 karakter)</li>}
                        {!page.description && <li className="text-xs text-amber-700">• Meta description ekleyin (120-160 karakter)</li>}
                        {!page.keywords && <li className="text-xs text-amber-700">• Keywords meta etiketi ekleyin (3-5 anahtar kelime)</li>}
                        {!page.h1 && <li className="text-xs text-amber-700">• H1 başlığı ekleyin (sayfada tek olmalı)</li>}
                        {page.title && page.title.length > 60 && <li className="text-xs text-amber-700">• Title çok uzun ({page.title.length} karakter) — 60 karaktere kısaltın</li>}
                        {page.description && page.description.length > 160 && <li className="text-xs text-amber-700">• Description çok uzun ({page.description.length} karakter) — 160 karaktere kısaltın</li>}
                      </ul>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {filtered.length === 0 && (
        <div className="text-center py-16 bg-white rounded-2xl border border-stone-100">
          <div className="w-14 h-14 flex items-center justify-center mx-auto mb-3 bg-stone-100 rounded-full">
            <i className="ri-search-line text-stone-400 text-2xl"></i>
          </div>
          <p className="text-stone-500 font-medium text-sm">Bu filtreye uygun sayfa bulunamadı</p>
        </div>
      )}

      {/* Legend */}
      <div className="mt-4 flex items-center gap-4 flex-wrap">
        <p className="text-xs text-stone-400 font-medium">Skor Göstergesi:</p>
        {[
          { label: "İyi (80-100)", color: "bg-emerald-400" },
          { label: "Orta (50-79)", color: "bg-amber-400" },
          { label: "Eksik (0-49)", color: "bg-rose-400" },
        ].map((l) => (
          <div key={l.label} className="flex items-center gap-1.5">
            <div className={`w-3 h-3 rounded-full ${l.color}`}></div>
            <span className="text-xs text-stone-500">{l.label}</span>
          </div>
        ))}
        <div className="flex items-center gap-3 ml-auto flex-wrap">
          {[
            { label: "T", title: "Title" },
            { label: "D", title: "Description" },
            { label: "K", title: "Keywords" },
            { label: "H", title: "H1" },
          ].map((l) => (
            <span key={l.label} className="text-xs text-stone-400" title={l.title}>
              <span className="font-bold text-stone-600">{l.label}</span> = {l.title}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SeoStatus;
